Vendd.Scripts.load(function () {

    var showMap = function () {
        var $storeLocator = $('.x-store-locator');

        if ($storeLocator.length < 1)
            return;

        var $partner = $('.x-partner-box', $storeLocator);
        var $map = $('.x-google-map', $storeLocator);

        if ($map.length < 1 || $partner.length < 1)
            return;

        var opts = {
            lat: $partner.data('latitude'),
            lng: $partner.data('longitude'),
            html: $('.box-info', $partner).html()
        };

        $map.get(0).create([opts]);
    };

    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.GoogleMapsLoaded, 'storeMap', showMap);
});